export function isBatchComplete(status: string | undefined): boolean {
  return status === 'ready' || status === 'done';
}
